"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Profile/Modals/AvatarPicker/Form/AvatarCropper.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _file = require('shared/services/file');
var _uuid = require('shared/services/uuid');
var _Form = require('web/components/Form');
var _ImageCropper = require('web/components/ImageCropper'); var _ImageCropper2 = _interopRequireDefault(_ImageCropper);

const CROPPED_AVATAR_SIZE = 128









const AvatarCropper = ({
  file,
  onClose,
  onReupload,
  onSubmit,
  isSubmitting,
}) => {
  const previewContainerID = _react.useMemo.call(void 0, () => `preview-container-${_uuid.uuidv4.call(void 0, )}`, [])

  const handleSubmit = _react.useCallback.call(void 0, 
    (cropper) => {
      const dataURL = _optionalChain([cropper, 'access', _ => _.getCroppedCanvas, 'call', _2 => _2({
        width: CROPPED_AVATAR_SIZE,
        height: CROPPED_AVATAR_SIZE,
      }), 'optionalAccess', _3 => _3.toDataURL, 'call', _4 => _4()])

      if (!dataURL) return
      onSubmit(_file.dataURLToFile.call(void 0, dataURL, 'avatar'))
    },
    [onSubmit],
  )

  return (
    _react2.default.createElement(_ImageCropper2.default, {
      file: file,
      onConfirm: handleSubmit,
      onCancel: onClose,
      isSubmitting: isSubmitting,
      preview: `#${previewContainerID}`,
      aspectRatio: 1,
      className: "avatar-cropper--container", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}

      , _react2.default.createElement('div', { className: "avatar-cropper--preview-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        , _react2.default.createElement('div', { id: previewContainerID, className: "avatar-cropper--preview-box", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} )
        , _react2.default.createElement(_Form.Button, { isMinimalistic: true, onClick: onReupload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "Upload a different image"   )
      )
    )
  )
}

exports. default = AvatarCropper
